export const CHECKOUT_OPTIONS = {
  FULL_PAYMENT: 'FULL_PAYMENT',
  PARTIAL: 'PARTIAL',
  ASSESSOR: 'ASSESSOR',
};
